/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { ToolTip, Link, DeleteMessage, isEmptyObject, Icon } from '@insticator/insticator-ui'; // iui-material
import ContentIndicator from 'material/embeds/contentindicator/contentindicator';
import Status from 'material/embeds/status/status';
// utils
import { url } from 'utils/urls';
import { generateName } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedcard/embedcard_styles';



/* ========== ~~~~~~~~~~ EMBED CARD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EmbedCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editEmbedClicked: false,
            embedAnalyticsClicked: false,
            emailCollectionClicked: false,
            deleteEmbedClicked: false,
            labelsToggled: false,
            divElement: null
        }
    }
    componentDidUpdate(prevProps) {
        // reset state if delete embed call fails
        if ( this.state.deleteEmbedClicked && prevProps.disableEmbedCards && !this.props.disableEmbedCards) {
            this.setState({ deleteEmbedClicked: false })
        }
    }

    handleEditEmbedClicked = () => {
        this.setState({ editEmbedClicked: true });
        this.props.editEmbed(this.props.embedUUID)
    };

    handleViewAnalyticsClicked = () => {
        this.setState({ embedAnalyticsClicked: true });
        this.props.viewAnalytics(this.props.embedUUID)

    };

    handleEmailCollectionClicked = () => {
        this.setState({ emailCollectionClicked: true });
        this.props.viewEmails(this.props.embedUUID, this.props.name)

    };

    handleDeleteEmbedClicked = () => {
        this.setState({ deleteEmbedClicked: true });
        this.props.deleteEmbed(this.props.embedUUID);
    };

    handleEmbedImageClicked = () => this.props.editPermitted ? this.handleEditEmbedClicked() : this.handleViewAnalyticsClicked();

    _renderEditEmbedLink = () =>
        <ToolTip position={`top`} action={`mouseenter`} content={`Edit Embed`}>
            <Link type={`action`}
                  text={``}
                  color={`neutral`}
                  action={this.handleEditEmbedClicked}
                  name={`edit`}
                  disabled={this.state.embedAnalyticsClicked || this.state.deleteEmbedClicked}
                  operation={`load`}
                  processing={this.state.editEmbedClicked}
                  icon={`pen`}
                  iconOnly />
        </ToolTip>;

    _renderViewAnalyticsButton = () =>
        !this.props.mockupGenerator && <ToolTip position={`top`} action={`mouseenter`} content={`View Analytics`}>
            <Link type={`action`}
                  text={``}
                  color={`neutral`}
                  action={this.handleViewAnalyticsClicked}
                  disabled={this.state.editEmbedClicked || this.state.deleteEmbedClicked}
                  operation={`load`}
                  processing={this.state.embedAnalyticsClicked}
                  name={`viewanalytics`}
                  icon={`chart-line`}
                  iconOnly />
        </ToolTip>;

    _renderEditLabelsButton = () =>
        <ToolTip position={`top`} action={`mouseenter`} content={`Edit Labels`}>
            <Link type={`action`}
                  text={``}
                  color={`neutral`}
                  action={this.props.editLabels}
                  disabled={this.state.editEmbedClicked || this.state.deleteEmbedClicked}
                  operation={`load`}
                  name={`editlabels`}
                  icon={`tag`}
                  iconOnly />
        </ToolTip>;

    _renderArchiveButton = () =>
        <ToolTip position={`top`} action={`mouseenter`} content={!this.props.status ? `Archive` : `You can not archive an embed that has online status. To archive this embed please take it offline first.`}>
            <Link type={`action`}
                  text={``}
                  color={`neutral`}
                  action={()=>this.props.archiveEmbed(this.props.embedUUID, this.props.name)}
                  disabled={this.state.editEmbedClicked || this.state.deleteEmbedClicked || this.props.status }
                  operation={`load`}
                  processing={this.props.archiving}
                  name={`archive`}
                  icon={`archive`}
                  iconOnly />
        </ToolTip>;

    _renderUnArchiveButton = () =>
        <Link type={`action`}
              text={`Unarchive`}
              color={`primary`}
              action={()=>this.props.unarchiveEmbed(this.props.embedUUID, this.props.name)}
              disabled={this.state.editEmbedClicked || this.state.deleteEmbedClicked || this.props.status }
              operation={`load`}
              processing={this.props.archiving}
              name={`unarchive`}
              icon={`archive`}
               />;

    _renderDeleteEmbedButton = () =>
        this.props.mocked && <ToolTip position={`top`} action={`mouseenter`} content={`Delete Embed`}>
            <Link type={`modal`}
                  text={``}
                  color={`neutral`}
                  action={<DeleteMessage itemType={'embed'} itemName={this.props.name} primaryAction={this.handleDeleteEmbedClicked} />}
                  disabled={this.state.editEmbedClicked || this.state.embedAnalyticsClicked}
                  operation={`delete`}
                  processing={this.state.deleteEmbedClicked}
                  name={`deleteembed`}
                  icon={`trash-alt`}
                  iconOnly />
        </ToolTip>;

    _renderEmailCollectionButton = () => {
        if(!this.props.addOns.includes('USER_DATA_COLLECTION')) return null;
        return !this.props.mockupGenerator && <ToolTip position={`top`} action={`mouseenter`} content={`View Collected Emails`}>
            <Link type={`action`}
                  text={``}
                  color={`neutral`}
                  action={this.handleEmailCollectionClicked}
                  disabled={this.state.editEmbedClicked || this.state.deleteEmbedClicked}
                  operation={`load`}
                  processing={this.state.emailCollectionClicked}
                  name={`viewemails`}
                  icon={`envelope`}
                  iconOnly />
        </ToolTip>
    };

    showText = () => this.props.status ? 'online' : 'offline';

    renderLabels = () => !!this.props.labels && this.props.labels.map((label, idx) => !!label && <div className={'label'} key={`${idx}-${label}`}>{label}</div>);

    renderLabelToggle = (labelsHeight) => {
        if(labelsHeight > 43){
            return (
                <div className={'label toggle'} onClick={() => this.setState({labelsToggled: !this.state.labelsToggled})}>
                    <Icon name={!this.state.labelsToggled ? 'chevron-down' : 'chevron-up'} />
                </div>
            )
        }
    };

    getContentCount = (activeContents) => {
        let liveContentCount = 0;
        activeContents && Object.keys(activeContents).forEach(type => liveContentCount += this.props.activeContents[type]);
        return liveContentCount;
    };

    render() {
        const labelsHeight = this.state.divElement && this.state.divElement.scrollHeight;
        const status = this.props.status;
        const name = this.props.name;
        const site = this.props.site;
        const posterImage = this.props.posterImage ? this.props.posterImage : `${url.image}/logo-insticator-icon.svg`;
        const hasImage = !!this.props.posterImage;
        const embedClicked = this.props.disableEmbedCards && !this.state.editEmbedClicked && !this.state.embedAnalyticsClicked;
        const clickedState = this.state.editEmbedClicked || this.state.embedAnalyticsClicked || this.state.deleteEmbedClicked;
        return(
            <div className={`embedcard ${this.props.classes.embedcard} disabled-${embedClicked} ${status} hasImage-${hasImage} name-${generateName(name)} archived-${this.props.archived}`}>
                <div className={`cover disabled-${clickedState}`} style={{backgroundImage:`url(${posterImage})`}}>
                    <div className={`overlay`} />
                    <div className={'labelcontainer'}>
                        <div className={'hotspot'} onClick={this.handleEmbedImageClicked} />
                        <div className={`labels labelstoggled-${this.state.labelsToggled}`} ref={ (divElement) => { !this.state.divElement && this.setState({divElement}) } } onClick={this.handleEmbedImageClicked}>
                            {this.renderLabels()}
                        </div>
                        {this.renderLabelToggle(labelsHeight)}
                    </div>
                </div>
                <div className={`details`}>
                    <ToolTip position={`top`} action={`mouseenter`} content={name}>
                        <div className={`name`} >{name}</div>
                    </ToolTip>
                    <ToolTip position={`top`} action={`mouseenter`} content={site}>
                        <div className={`site`} >{site}</div>
                    </ToolTip>
                </div>
                <div className={`info`}>
                    <label>{this.getContentCount(this.props.activeContents)} Live Cards:</label>
                    {!this.props.activeContents || isEmptyObject(this.props.activeContents) ? <span className='nocontent'>No Content</span> :
                        <ContentIndicator type={`indicator`} processClick={null} activeContents={this.props.activeContents} disabled={false} withCount={true} />
                    }
                </div>
                {this.props.archived ? <div className={`actions`}>{this._renderUnArchiveButton()}</div> : <div className={`actions`}>
                    <div className={`controls loading`}>
                        {this.props.editPermitted ? this._renderEditEmbedLink() : null}
                        {this._renderViewAnalyticsButton()}
                        {this._renderEmailCollectionButton()}
                        {this._renderEditLabelsButton()}
                        {this._renderArchiveButton()}
                        {this._renderDeleteEmbedButton()}
                    </div>
                    <div className={`status`}>
                        <Status live={status} variant={`dot`} type={`indicator`} /> <span className={`text`}>{this.showText()}</span>
                    </div>
                </div>}

            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmbedCard);
